import styled from 'styled-components'
import { tabletBreakpoint, desktopBreakpoint } from 'react-components'

export const StyledFooterLink = styled.a`
    font-family: ${props => props.theme.typography.font.family.lato};
    font-size: 0.9375rem;
    line-height: 1.73;
    color: ${props => props.theme.colors.tfwBlack87};
    text-decoration: none;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin: 0 ${props => props.theme.spacing.medium};
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        margin: 0 0.8125rem;
    }
`
